module.exports = __webpack_public_path__ + "fdaa015fd7ab3d1a7a3edf672ee93c83.obj";